module.exports = __webpack_public_path__ + "download-pdf.68086e4abbef8a18e60d.svg";